import client from "../../../api/client";

export default async function logoutUser() {
  const response = await client.post("/auth/logout");
  return response.data;
}